import { render } from "./LanguageChanger.vue?vue&type=template&id=11e2f408&ts=true"
import script from "./LanguageChanger.vue?vue&type=script&lang=ts"
export * from "./LanguageChanger.vue?vue&type=script&lang=ts"

import "./LanguageChanger.vue?vue&type=style&index=0&id=11e2f408&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__